import { Col } from 'antd';
import React from 'react';
import FormItem from '../../utils/FormItem';
import { Switch } from '../../../lists/listComponents/Switch';

interface SwitchFieldProps {
  name: string;
  label: string;
  hidden: boolean
}

const SwitchField: React.FC<SwitchFieldProps> = ({ name, hidden, label }) => {
  if (hidden) {
    return null
  }

  return (
    <Col span={12}>
      <FormItem label={label} top>
        <Switch name={name} />
      </FormItem>
    </Col>
  )
};

export default SwitchField;

